import FormModal from '@insurancemenu/imenu-components-lib/dist/components/modals/FormModal';
import React from 'react';
import { colors, InputText, TextArea } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { EditResponseDocumentModalStore } from 'store/pages/rfq/rfq-response/proposal-response/editResponseDocumentModalStore';
import { Edit } from '@insurancemenu/imenu-components-lib/dist/icons';
import { FormBodyWrapperStyled } from './styles';

interface Props {
  modalStore: EditResponseDocumentModalStore;
}

const EditResponseDocumentModal: React.FC<Props> = observer(({ modalStore }) => {
  const { showEditDocumentModal, form, editResponseDocument, closeEditDocumentModal } = modalStore;

  const onEditDocument = async (): Promise<void> => {
    closeEditDocumentModal();
    await editResponseDocument();
  };

  return (
    <FormModal
      show={showEditDocumentModal}
      title="Edit Document"
      subtitle={
        <span>
          Update the document&apos;s details. Keep in mind that the name
          <br />
          must be unique among all your uploaded documents.
        </span>
      }
      icon={<Edit width="5.6rem" color={colors.green[600]} />}
      formContent={
        <FormBodyWrapperStyled>
          <InputText
            label="Document Name"
            name="docName"
            maxLength={30}
            width="50rem"
            value={form.fields.docName.value}
            onChange={form.onFieldChange}
            validationPassed={!form.fields.docName.unpassedValidationMsg}
            validationMessage={form.fields.docName.unpassedValidationMsg}
          />
          <TextArea
            label="Description"
            maxLength={500}
            name="description"
            width="50rem"
            value={form.fields.description.value}
            onChange={form.onFieldChange}
            validationPassed={!form.fields.description.unpassedValidationMsg}
            validationMessage={form.fields.description.unpassedValidationMsg}
          />
        </FormBodyWrapperStyled>
      }
      isFormValid={form.basicFieldsValidationsPassed}
      closeButtonText="Cancel"
      submitButtonText="Save"
      onSubmit={onEditDocument}
      onClose={closeEditDocumentModal}
    />
  );
});

export default EditResponseDocumentModal;
